// Minimal structural shapes so `attributeOrderSort`/`attributeSpeciesFilter`
// work across both species-level (state.speciesAttributes.*, e.g. `Breed`)
// and deployment-level (state.deploymentAttributes.*, e.g. `DeploymentBreed`)
// attribute collections, which don't share a common base type.
export interface OrderedAttribute {
  order: number;
}

export interface SpeciesScopedAttribute {
  species_id: number;
}

export function attributeOrderSort(
  a: OrderedAttribute,
  b: OrderedAttribute,
): number {
  return a.order - b.order;
}

export function attributeSpeciesFilter(
  speciesId: number | null,
): (attr: SpeciesScopedAttribute) => boolean {
  return attr => attr.species_id === speciesId;
}

export function getActiveSpeciesAttributes<
  // Callers pass results of untyped JS selectors (e.g. useSelector(getAges)),
  // which TS sees as `any`. Without this default, `T` resolves to the bare
  // constraint instead of `any`, which then fails downstream against the
  // (loosely typed) shared settings-table row types those callers feed into.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  T extends OrderedAttribute & { deprecated?: boolean } = any,
>(stateSlice: Record<string, T>): T[] {
  return Object.values(stateSlice)
    .filter(a => !a?.deprecated)
    .sort(attributeOrderSort);
}
